(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-hotspots"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('graywind-image-hotspots')) {
  customElements.define('graywind-image-hotspots', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('toggle', (event) => {
        const detail = event.target;
        if (!detail.matches('.sf-mb-detail')) return;
        if (detail.open) this.selectMobile(detail.dataset.mobileHotspot);
        else this.syncMobileDots();
      }, { ...options, capture: true });
      const openDetail = this.querySelector('.sf-mb-detail[open]');
      if (openDetail) this.selectMobile(openDetail.dataset.mobileHotspot);
      else this.syncMobileDots();
      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-mobile-dot]');
        if (dot && this.contains(dot)) { this.selectMobile(dot.dataset.mobileDot); return; }
        const button = event.target.closest('.sf-hs-btn');
        if (!button || !this.contains(button)) return;
        const spot = button.closest('.sf-hs-spot');
        const open = !spot.classList.contains('active');
        this.closeAll();
        if (open) this.openSpot(spot);
      }, options);
      this.addEventListener('pointerover', (event) => {
        if (event.pointerType !== 'mouse') return;
        const spot = event.target.closest('.sf-hs-spot');
        if (!spot || spot.contains(event.relatedTarget)) return;
        this.closeAll();
        this.openSpot(spot);
      }, options);
      this.addEventListener('pointerout', (event) => {
        if (event.pointerType !== 'mouse') return;
        const spot = event.target.closest('.sf-hs-spot');
        if (!spot || spot.contains(event.relatedTarget)) return;
        this.closeTimer = setTimeout(() => this.closeAll(), 180);
      }, options);
      this.addEventListener('pointerover', (event) => {
        if (event.target.closest('.sf-hs-spot')) clearTimeout(this.closeTimer);
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeAll();
      }, options);
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const active = this.querySelector('.sf-hs-spot.active');
        if (active?.contains(document.activeElement)) active.querySelector('button').focus();
        this.closeAll();
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const id = event.detail?.blockId;
        const spot = [...this.querySelectorAll('[data-hotspot]')].find((item) => item.dataset.hotspot === id);
        if (!spot) return;
        this.closeAll();
        this.openSpot(spot);
        if (window.matchMedia('(max-width: 767px)').matches) this.selectMobile(id);
      }, options);
      document.addEventListener('shopify:block:deselect', () => this.closeAll(), options);
    }
    selectMobile(id) {
      const details = [...this.querySelectorAll('.sf-mb-detail')];
      if (!details.some((detail) => detail.dataset.mobileHotspot === id)) return;
      details.forEach((detail) => { detail.open = detail.dataset.mobileHotspot === id; });
      this.querySelectorAll('[data-mobile-image]').forEach((panel) => {
        panel.hidden = panel.dataset.mobileImage !== id;
      });
      this.syncMobileDots();
    }
    syncMobileDots() {
      const open = this.querySelector('.sf-mb-detail[open]');
      this.querySelectorAll('[data-mobile-dot]').forEach((dot) => {
        const selected = dot.dataset.mobileDot === open?.dataset.mobileHotspot;
        dot.classList.toggle('is-selected', selected);
        dot.setAttribute('aria-expanded', String(selected));
      });
    }
    openSpot(spot) {
      clearTimeout(this.closeTimer);
      spot.classList.add('active');
      spot.querySelector('button').setAttribute('aria-expanded', 'true');
      const card = spot.querySelector('.sf-hs-card');
      card.style.removeProperty('translate');
      const rect = card.getBoundingClientRect();
      let offset = 0;
      if (rect.right > window.innerWidth - 16) offset = window.innerWidth - 16 - rect.right;
      if (rect.left + offset < 16) offset += 16 - (rect.left + offset);
      if (offset) card.style.translate = `${offset}px 0`;
    }
    closeAll() {
      clearTimeout(this.closeTimer);
      this.querySelectorAll('.sf-hs-spot').forEach((spot) => {
        spot.classList.remove('active');
        spot.querySelector('button').setAttribute('aria-expanded', 'false');
      });
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.controller?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gw-image-story')) {
  customElements.define('gw-image-story', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = [...this.querySelectorAll('[data-story-item]')];
      this.panels = [...this.querySelectorAll('[data-story-panel]')];
      this.track = this.querySelector('.gis-track');
      this.mobileCards = [...this.querySelectorAll('[data-story-mobile]')];
      this.mobileIndex = 0;
      this.mobileFrame = null;
      this.setMobileIndex(0);
      this.track?.addEventListener('scroll', () => {
        if (this.mobileFrame !== null) return;
        this.mobileFrame = requestAnimationFrame(() => {
          this.mobileFrame = null;
          if (!this.track.clientWidth) return;
          this.setMobileIndex(Math.round(this.track.scrollLeft / this.track.clientWidth));
        });
      }, { ...options, passive: true });
      this.desktop = window.matchMedia('(min-width: 768px)');
      this.frame = null;
      this.editorBlock = null;
      this.selectedId = null;
      if (this.items.length) this.select(this.items[0].dataset.storyItem);
      this.addEventListener('click', (event) => {
        const progress = event.target.closest('[data-story-progress]');
        if (progress && this.contains(progress)) {
          const index = this.mobileCards.findIndex((card) => card.dataset.storyMobile === progress.dataset.storyProgress);
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.goToMobile(index, behavior);
          return;
        }
        const item = event.target.closest('[data-story-item]');
        if (item && this.contains(item)) this.select(item.dataset.storyItem);
      }, options);
      this.addEventListener('focusin', (event) => {
        const item = event.target.closest('[data-story-item]');
        if (item) this.select(item.dataset.storyItem);
      }, options);
      window.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      window.addEventListener('resize', () => {
        this.schedule();
        if (!this.desktop.matches) this.goToMobile(this.mobileIndex, 'auto');
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const id = event.detail?.blockId;
        if (!this.items.some((item) => item.dataset.storyItem === id)) return;
        this.editorBlock = id;
        this.select(id);
        if (!this.desktop.matches) {
          const index = this.mobileCards.findIndex((card) => card.dataset.storyMobile === id);
          this.goToMobile(index, 'auto');
        }
      }, options);
      document.addEventListener('shopify:block:deselect', (event) => {
        if (this.editorBlock === event.detail?.blockId) this.editorBlock = null;
      }, options);
    }
    setMobileIndex(index) {
      if (index < 0 || index >= this.mobileCards.length) return;
      this.mobileIndex = index;
      const id = this.mobileCards[index].dataset.storyMobile;
      this.querySelectorAll('[data-story-progress]').forEach((button) => {
        const active = button.dataset.storyProgress === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }
    goToMobile(index, behavior = 'auto') {
      if (!this.track || index < 0 || index >= this.mobileCards.length) return;
      this.setMobileIndex(index);
      this.track.scrollTo({ left: this.track.clientWidth * index, behavior });
    }
    schedule() {
      if (this.frame !== null || !this.desktop.matches || this.editorBlock) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateFromScroll();
      });
    }
    updateFromScroll() {
      if (!this.desktop.matches || this.editorBlock || !this.items.length) return;
      const target = window.innerHeight / 2;
      let closest = null;
      let distance = Infinity;
      this.items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
        const nextDistance = Math.abs(rect.top + rect.height / 2 - target);
        if (nextDistance < distance) { closest = item; distance = nextDistance; }
      });
      if (closest) this.select(closest.dataset.storyItem);
    }
    select(id) {
      if (this.selectedId === id || !this.items.some((item) => item.dataset.storyItem === id)) return;
      this.selectedId = id;
      this.items.forEach((item) => {
        const active = item.dataset.storyItem === id;
        item.classList.toggle('is-active', active);
        item.querySelector('button').setAttribute('aria-pressed', String(active));
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.storyPanel === id;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', String(!active));
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      if (this.mobileFrame !== null) cancelAnimationFrame(this.mobileFrame);
      this.frame = null;
      this.mobileFrame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
